import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { useSmartNavigate } from 'lib/hooks/useSmartNavigate';

import adminState from 'components/admin/lib/adminState';
import useUserPreferencesState from 'components/practice/UserPreferences/hooks/useUserPreferencesState';
import practiceState from 'components/practice/practiceState';
import Spinner from 'components/shared/spinner/spinner';
import state from 'components/state';

const PrivateRoutes = ({ type = '' }) => {
  const userState = useRecoilValue(state.userState);
  const practice = useRecoilValue(practiceState.currentPractice);
  const admin_state = useRecoilValue(adminState.current_admin);
  const location = useLocation();
  const { locationState } = useSmartNavigate();

  const { generalPreferences, isLoading } = useUserPreferencesState(['user_general']);
  const defaultRoute = generalPreferences.defaultRoute;

  const redirectState =
    locationState === null
      ? {
          returnTo: location
        }
      : { returnTo: locationState?.returnTo };

  const redirectTo = () => {
    if (admin_state.logged_in) return '/admin';
    if (practice.id) return '/portal';
    if (userState.logged_in) return '/myportal';
    return '/login';
  };

  if (type === 'private') return <Navigate state={redirectState} to={redirectTo()} />;

  if (type === 'admin') {
    return admin_state.logged_in ? (
      <Outlet />
    ) : (
      <Navigate state={redirectState} to="/admin/login" />
    );
  }

  if (!userState.logged_in) return <Navigate state={redirectState} to="/login" />;

  if (type === 'portal') {
    if (!practice.id) return <Navigate state={redirectState} to="/login" />;

    const isAtPortalRoot = location.pathname === '/portal' || location.pathname === '/portal/';

    if (isLoading && isAtPortalRoot) {
      return (
        <div className="flex h-screen w-full items-center justify-center">
          <Spinner />
        </div>
      );
    }

    // Redirect to default route if configured
    if (isAtPortalRoot && defaultRoute) {
      return <Navigate state={redirectState} to={`/portal/${defaultRoute}`} replace />;
    }

    return <Outlet />;
  }

  return <Outlet />;
};

export default PrivateRoutes;
